var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadover),expression:"loadover"}],staticClass:"intro"},[_c('div',[_c('video',{attrs:{"src":_vm.pageCate.info.attachment,"controls":"","muted":"","poster":""},domProps:{"muted":true}})]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageCate.info.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113f3892","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/go/introductionG.vue
// module id = null
// module chunks = 